<ca-modal-container modalTitle="{{ 'WORKFLOWS.WORKFLOW_TITLE' | translate }}" (dismiss)="dismiss('Canceled')">
    <form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate class="row gy-2">
        <div class="col-12">
            <input
                type="text"
                class="form-control"
                formControlName="title"
                placeholder="Workflow Title"
                required
                data-uit="create-workflow-name"
                [ngClass]="formGroup.get('title')?.errors && formGroup.get('title')?.dirty ? 'has-error' : ''"
            />
            <small *ngIf="formGroup.get('title')?.dirty && formGroup.get('title')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
            <small *ngIf="formGroup.get('title')?.dirty && formGroup.get('title')?.hasError('maxlength')" class="invalid-feedback">
                {{ 'WORKFLOWS.CREATOR.WORKFLOW_TITLE_SHOULD_NOT_EXCEED_256_CHARS' | translate }}
            </small>
            <small *ngIf="formGroup.get('title')?.dirty && formGroup.get('title')?.hasError('pattern')" class="invalid-feedback">
                {{ 'WORKFLOWS.CREATOR.WORKFLOW_TITLE_SHOULD_NOT_BEGIN_WITH_WHITESPACES' | translate }}
            </small>
            <div class="d-block mt-3" *ngIf="isPublicModule">
                <ca-input-checkbox formControlName="shouldUseTestFiles">{{ 'WORKFLOWS.USE_TEST_FILES' | translate }}</ca-input-checkbox>
            </div>
        </div>
        <div class="modal-buttons mt-3">
            <button
                type="submit"
                class="btn btn-primary float-end"
                caAutoFocus
                [disabled]="!formGroup.valid || isSubmitting"
                data-uit="create-workflow-create-button"
            >
                {{ 'WORKFLOWS.CREATOR.CREATE_NOW' | translate }}
            </button>
        </div>
    </form>
</ca-modal-container>
